import "./Title.css";
import "../../App.css";

const Title = ({ text }) => {
  return <div className="section-title">{text}</div>;
};

export default Title;
